export default {
  account: () => import("/vercel/path0/layouts/account.vue").then(m => m.default || m),
  checkout: () => import("/vercel/path0/layouts/checkout.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)
}